import { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Notification } from "../../../../@types/Notification";
import { IProtocolTableContent } from "../../../../@types/Protocol";
import { ProtocolsEmptyState } from "../../../../assets/icons/ProtocolsEmptyState";
import { Table } from "../../../../components/Table";
import { TableSkeleton } from "../../../../components/TableSkeleton";
import { NOTIFICATION } from "../../../../constants/localStorageKeys";
import { useToast } from "../../../../hooks/useToast";
import { safeStorage, safeJsonParse } from "../../../../utils/storage";
import { ImageContainer } from "../../../PatientPage/components/PatientAlertsTable/PatientAlertsTable.style";
import { AddProtocolButton } from "../../ProtocolList.styles";
import { protocolListColumns } from "../../ProtocolListColumns";

type ProtocolListTableProps = {
  content: IProtocolTableContent[];
  isLoading?: boolean;
  refetch(): void;
};

export function ProtocolListTable({
  content,
  isLoading = false,
  refetch,
}: ProtocolListTableProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleRowClick = async (content: any) => {
    navigate(`/protocol/builder/${content.id}`);
  };

  const handleAddProtocol = () => {
    navigate("/protocol/builder");
  };

  useEffect(() => {
    const notification = safeStorage.getItem(NOTIFICATION);
    const parsedNotification = safeJsonParse<Notification>(
      notification,
      {} as Notification
    );

    if (notification) {
      refetch();
      showToast(parsedNotification.message, parsedNotification.type);
      safeStorage.removeItem(NOTIFICATION);
    }
  }, []);

  if (isLoading) {
    return <TableSkeleton columnsNumber={8} />;
  }

  if (content && content.length > 0) {
    return (
      <>
        <AddProtocolButton onClick={handleAddProtocol}>
          {t("protocols_create")}
        </AddProtocolButton>
        <Table
          data={content}
          onRowClick={handleRowClick}
          emptyStateText={t("protocols_emptyState")}
          columns={protocolListColumns}
          showMaxContent
        />
      </>
    );
  }

  return (
    <>
      <AddProtocolButton onClick={handleAddProtocol}>
        {t("protocols_create")}
      </AddProtocolButton>
      <ImageContainer style={{ height: "800px", minHeight: "30px" }}>
        <ProtocolsEmptyState />
        <p>
          <Trans
            i18nKey="protocols_emptyStateHint"
            components={{ emphasis: <span /> }}
          />
        </p>
      </ImageContainer>
    </>
  );
}
